var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:({
    width: _vm.height + 'px',
    height: _vm.height + 'px',
    marginRight: _vm.marginRight + 'px',
    marginLeft: _vm.marginLeft + 'px',
  }),attrs:{"src":_vm.src,"alt":_vm.alt ? _vm.alt : _vm.code}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60be805d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flag.vue
// module id = 339
// module chunks = 1